<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "Customer"
})
</script>

<template>
  <div>custo</div>

</template>

<style scoped>

</style>